module.exports = __webpack_public_path__ + "img/svekketis.66fe83ec.jpg";